<template>
  <div>
  </div>
</template>

<script>
import { urlParam } from '@/utils/url'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      param: {}
    }
  },
  created() {
    // 获取链接的参数
    this.param = urlParam
    // 将原参数直接跳转到后端管理界面
    window.location.href = `http://www.booleanda.cc:9600?phone=${this.param.p}&oname=${this.param.oname}&code=${this.param.code}&timestamp=${this.param.id}`
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
}
</style>

